import ApiClient from "./ApiClient";
import Selectitem from "../models/shared/SelectItem";
import { TransportOptionType } from "../models/transport-option-type/TransportOptionType";

export default class TransportOptionTypeApiClient {
  apiClient: ApiClient;
  urlPrefix: string = "transport-option-types/";

  constructor() {
    this.apiClient = new ApiClient();
  }

  async getTransportOptionTypes() {
    const transportOptionTypes = await this.apiClient.get(this.urlPrefix);

    return <Selectitem<TransportOptionType>[]>transportOptionTypes;
  }
}
